import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import FormikInputField from 'components/forms/fields/FormikInputField';
import Button from 'components/buttons/Button';
import axios from 'data/axios';
import toast from 'react-hot-toast';
import useSession from 'hooks/useSession';
import mapUserProfile from 'models/mapping/mapUserProfile';
import { useRouter } from 'next/router';
import Link from 'next/link';

const initialValues = {
    email: '',
    password: ''
};

const schema = Yup.object().shape({
    email: Yup.string().email('Vnesi veljaven e-poštni naslov.').required('Vnesi svoj e-poštni naslov'),
    password: Yup.string().min(6, 'Geslo mora biti dolgo vsaj 6 znakov.').required('Vnesi svoje geslo')
});

const RegisterForm = () => {
    const { login } = useSession();
    const { push } = useRouter();
    const [serverError, setServerError] = useState<React.ReactNode>();
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const response = await axios.post('/public/register', values);
            const { access_token, user } = response.data;
            login(access_token, mapUserProfile(user));
            push('/zakljuci-registracijo');
            setSubmitting(false);
        } catch (e) {
            setSubmitting(false);
            const errors = e.response.data.errors;
            if (errors.filter((e) => e.detail.includes('email has already been taken'))) {
                setServerError(
                    <>
                        Uporabnik s tem e-poštnim naslovom že obstaja. Si se{' '}
                        <Link href="/prijava" className="underline font-medium">
                            želel prijaviti
                        </Link>
                        ?
                    </>
                );
            }

            toast.error('Registracija ni uspela. Preveri podatke in poskusi ponovno.', { duration: 5000 });
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={handleSubmit}
            validateOnBlur={true}
            validateOnChange={true}
        >
            {({ isSubmitting, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <FormikInputField
                        name="email"
                        label="E-pošta"
                        type={'email'}
                        placeholder="Vnesi svoj e-poštni naslov"
                        autocomplete="username"
                    />
                    <div className="mt-4">
                        <FormikInputField
                            name="password"
                            label="Geslo"
                            type="password"
                            placeholder="Vnesi svoje geslo"
                            autocomplete={'new-password'}
                        />
                    </div>
                    <div className="flex flex-col mt-6">
                        <Button color={'secondary'} variant={'contained'} type={'submit'} disabled={isSubmitting}>
                            <span className="font-bold">Nadaljuj</span>
                        </Button>
                    </div>
                    {serverError && <div className="mt-2">{serverError}</div>}
                </form>
            )}
        </Formik>
    );
};

export default RegisterForm;
